import { Component, Directive, Input, Output, TemplateRef, ViewChild,
         ViewContainerRef, ContentChild, OnInit } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { TemplatePortalDirective, TemplatePortal } from '@angular/material';
export type StepState = number;
export let StepState: any = {};
StepState.None =  /** @type {?} */(( <any>'none'));
StepState.Required =  /** @type {?} */(( <any>'required'));
StepState.Complete =  /** @type {?} */(( <any>'complete'));
StepState[StepState.None] = "None";
StepState[StepState.Required] = "Required";
StepState[StepState.Complete] = "Complete";

export class TdStepLabelDirective extends TemplatePortalDirective {
/**
 * @param {?} templateRef
 * @param {?} viewContainerRef
 */
constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[td-step-label]ng-template',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: ViewContainerRef, },
];
}

function TdStepLabelDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdStepLabelDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdStepLabelDirective.ctorParameters;
}

export class TdStepActionsDirective extends TemplatePortalDirective {
/**
 * @param {?} templateRef
 * @param {?} viewContainerRef
 */
constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[td-step-actions]ng-template',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: ViewContainerRef, },
];
}

function TdStepActionsDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdStepActionsDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdStepActionsDirective.ctorParameters;
}

export class TdStepSummaryDirective extends TemplatePortalDirective {
/**
 * @param {?} templateRef
 * @param {?} viewContainerRef
 */
constructor(templateRef: TemplateRef<any>, viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[td-step-summary]ng-template',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: ViewContainerRef, },
];
}

function TdStepSummaryDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdStepSummaryDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdStepSummaryDirective.ctorParameters;
}

export class TdStepComponent implements OnInit {
private _active: boolean = false;
private _state: StepState = StepState.None;
private _disabled: boolean = false;
private _contentPortal: TemplatePortal;
/**
 * @return {?}
 */
get stepContent(): TemplatePortal {
    return this._contentPortal;
  }

   _content: TemplateRef<any>;
   stepLabel: TdStepLabelDirective;
   stepActions: TdStepActionsDirective;
   stepSummary: TdStepSummaryDirective;
/**
 * label?: string
 * Sets label of [TdStepComponent] header.
 * Defaults to 'Step #'
 */
label: string;
/**
 * sublabel?: string
 * Sets sublabel of [TdStepComponent] header.
 */
sublabel: string;
/**
 * active?: boolean
 * Toggles [TdStepComponent] between active/deactive.
 * @param {?} active
 * @return {?}
 */
set active(active: boolean) {
    this._setActive(active);
  }
/**
 * @return {?}
 */
get active(): boolean {
    return this._active;
  }
/**
 * disabled?: boolean
 * Disables icon and header, blocks click event and sets [TdStepComponent] to deactive if 'true'.
 * @param {?} disabled
 * @return {?}
 */
set disabled(disabled: boolean) {
    if (disabled && this._active) {
      this._active = false;
      this._onDeactivated();
    }
    this._disabled = disabled;
  }
/**
 * @return {?}
 */
get disabled(): boolean {
    return this._disabled;
  }
/**
 * state?: StepState or ['none' | 'required' | 'complete']
 * Sets state of [TdStepComponent] depending on value.
 * Defaults to [StepState.None | 'none'].
 * @param {?} state
 * @return {?}
 */
set state(state: StepState) {
    switch (state) {
      case StepState.Complete:
        this._state = StepState.Complete;
        break;
      case StepState.Required:
        this._state = StepState.Required;
        break;
      default:
        this._state = StepState.None;
        break;
    }
  }
/**
 * @return {?}
 */
get state(): StepState {
    return this._state;
  }
/**
 * activated?: function
 * Event emitted when [TdStepComponent] is activated.
 */
onActivated: EventEmitter<void> = new EventEmitter<void>();
/**
 * deactivated?: function
 * Event emitted when [TdStepComponent] is deactivated.
 */
onDeactivated: EventEmitter<void> = new EventEmitter<void>();
/**
 * @param {?} _viewContainerRef
 */
constructor(private _viewContainerRef: ViewContainerRef) {}
/**
 * @return {?}
 */
ngOnInit(): void {
    this._contentPortal = new TemplatePortal(this._content, this._viewContainerRef);
  }
/**
 * Toggle active state of [TdStepComponent]
 * retuns 'true' if successful, else 'false'.
 * @return {?}
 */
toggle(): boolean {
    return this._setActive(!this._active);
  }
/**
 * Opens [TdStepComponent]
 * retuns 'true' if successful, else 'false'.
 * @return {?}
 */
open(): boolean {
    return this._setActive(true);
  }
/**
 * Closes [TdStepComponent]
 * retuns 'true' if successful, else 'false'.
 * @return {?}
 */
close(): boolean {
    return this._setActive(false);
  }
/**
 * Returns 'true' if [state] equals to [StepState.Complete | 'complete'], else 'false'.
 * @return {?}
 */
isComplete(): boolean {
    return this._state === StepState.Complete;
  }
/**
 * Method to change active state internally and emit the [onActivated] event if 'true' or [onDeactivated]
 * event if 'false'. (Blocked if [disabled] is 'true')
 * returns true if successfully changed state
 * @param {?} newActive
 * @return {?}
 */
private _setActive(newActive: boolean): boolean {
    if (this._disabled) {
      return false;
    }
    if (this._active !== newActive) {
      this._active = newActive;
      if (newActive) {
        this._onActivated();
      } else {
        this._onDeactivated();
      }
      return true;
    }
    return false;
  }
/**
 * @return {?}
 */
private _onActivated(): void {
    this.onActivated.emit(undefined);
  }
/**
 * @return {?}
 */
private _onDeactivated(): void {
    this.onDeactivated.emit(undefined);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'td-step',
  templateUrl: './step.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_content': [{ type: ViewChild, args: [TemplateRef, ] },],
'stepLabel': [{ type: ContentChild, args: [TdStepLabelDirective, ] },],
'stepActions': [{ type: ContentChild, args: [TdStepActionsDirective, ] },],
'stepSummary': [{ type: ContentChild, args: [TdStepSummaryDirective, ] },],
'label': [{ type: Input, args: ['label', ] },],
'sublabel': [{ type: Input, args: ['sublabel', ] },],
'active': [{ type: Input, args: ['active', ] },],
'disabled': [{ type: Input, args: ['disabled', ] },],
'state': [{ type: Input, args: ['state', ] },],
'onActivated': [{ type: Output, args: ['activated', ] },],
'onDeactivated': [{ type: Output, args: ['deactivated', ] },],
};
}

function TdStepComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdStepComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdStepComponent.ctorParameters;
/** @type {?} */
TdStepComponent.propDecorators;
/** @type {?} */
TdStepComponent.prototype._active;
/** @type {?} */
TdStepComponent.prototype._state;
/** @type {?} */
TdStepComponent.prototype._disabled;
/** @type {?} */
TdStepComponent.prototype._contentPortal;
/** @type {?} */
TdStepComponent.prototype._content;
/** @type {?} */
TdStepComponent.prototype.stepLabel;
/** @type {?} */
TdStepComponent.prototype.stepActions;
/** @type {?} */
TdStepComponent.prototype.stepSummary;
/**
 * label?: string
 * Sets label of [TdStepComponent] header.
 * Defaults to 'Step #'
 * @type {?}
 */
TdStepComponent.prototype.label;
/**
 * sublabel?: string
 * Sets sublabel of [TdStepComponent] header.
 * @type {?}
 */
TdStepComponent.prototype.sublabel;
/**
 * activated?: function
 * Event emitted when [TdStepComponent] is activated.
 * @type {?}
 */
TdStepComponent.prototype.onActivated;
/**
 * deactivated?: function
 * Event emitted when [TdStepComponent] is deactivated.
 * @type {?}
 */
TdStepComponent.prototype.onDeactivated;
/** @type {?} */
TdStepComponent.prototype._viewContainerRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
